module.exports = __webpack_public_path__ + "img/copy-blue.92c8fbfc.svg";